import api from '@/api'
import { _surfaceErrorMessage, _surfaceSuccessMessage } from '@/snackbar'
import { ENTITIES } from '../constants'

export const getters = {
  getRatingsForUserId: (state) => (userId) =>
    state.ratings.filter((rating) => rating.userId === userId),

  getRatingsForSkillId: (state) => (skillId) =>
    state.ratings.filter((rating) => rating.skillId === skillId),

  getRatingProficiencyForSkillIdAndUserId() {
    return (skillId, userId) => {
      const ratingsForSkillId = this.getRatingsForSkillId(skillId)
      const userWithRatingForSkill = ratingsForSkillId.find((rating) => rating.userId === userId)
      return userWithRatingForSkill ? userWithRatingForSkill.proficiency : null
    }
  },

  getSkillRatingsForUser() {
    return (userId) => {
      const relevantRatings = this.getRatingsForUserId(userId)
      return relevantRatings.map((rating) => {
        const skill = this.getEntityById(ENTITIES.SKILLS, rating.skillId)
        return { ...rating, skill }
      })
    }
  },
}

export const actions = {
  async fetchRatings() {
    this.ratings = await api.fetchRatings()
  },

  async updateRating(payload) {
    try {
      const rating = await api.updateRating(payload)
      this.ratings = this.ratings.map((r) => (r.id === rating.id ? { ...r, ...rating } : r))
      _surfaceSuccessMessage('Update succeeded!')
    } catch {
      _surfaceErrorMessage('Update failed! Please try again later.')
    }
  },
}
